import React from "react";
import { MACRO_COLORS } from "../macroColors";
import { formatMacro } from "../planMapping";
import type { Macros } from "../types/plans.types";

const TOTALS: Array<{ key: keyof Macros; label: string }> = [
  { key: "calories", label: "Total calories" },
  { key: "carbs", label: "Total carbs" },
  { key: "protein", label: "Total protein" },
  { key: "fat", label: "Total fat" },
];

export interface PlanMacroSummaryProps {
  macros: Macros;
}

/**
 * The day's totals, across the top of the builder. Each meal counts as the
 * average of its options rather than their sum — they are alternatives the
 * client picks between, not extra food. See `mealMacros`.
 */
const PlanMacroSummary: React.FC<PlanMacroSummaryProps> = ({ macros }) => (
  <section className="flex flex-wrap items-center justify-between gap-x-8 gap-y-3 rounded-md border border-line bg-white px-5 sm:px-6 py-4">
    {TOTALS.map((total) => (
      <div key={total.key} className="flex items-center gap-2">
        <span
          aria-hidden="true"
          className="h-3.5 w-[3px] flex-shrink-0 rounded-full"
          style={{ backgroundColor: MACRO_COLORS[total.key] }}
        />
        <span className="text-[13px] 3xl:text-[14px] text-[#8B8D98]">
          {total.label}:
        </span>
        <span className="text-[14px] 3xl:text-[15px] font-medium text-ink">
          {formatMacro(macros[total.key])}
        </span>
      </div>
    ))}
  </section>
);

export default PlanMacroSummary;
